import React, { createContext, useState, useContext } from "react";
import styled, { keyframes } from "styled-components";

const NotificationContext = createContext();

const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({ message: "", visible: false });

  const showNotification = (message, duration = 5000) => {
    setNotification({ message, visible: true });
    setTimeout(() => {
      setNotification({ message: "", visible: false });
    }, duration);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification.visible && <Notification message={notification.message} />}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
`;

const textAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const NotificationWrapper = styled.div`
  position: fixed;
  top: 10vh;
  right: 25px;
  padding: 12px 20px;
  background: transparent;
  backdrop-filter: blur(10px);
  border-radius: 20px;
  color: #FF914D;
  font-size: 1.5rem; // Increased font size
  font-family: 'Montserrat', sans-serif; // Changed font family to a modern one
  font-weight: 700; // Increased font weight
  letter-spacing: 1px; // Added letter spacing
  // box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 2000;
  text-align: center;
  max-width: 350px;
  word-wrap: break-word;
  animation: ${fadeInOut} 5s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

const Text = styled.span`
  animation: ${textAnimation} 2s infinite;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.6), 0 0 15px rgba(0, 0, 0, 0.4); // Added whitish glow effect
`;

const Notification = ({ message }) => (
  <NotificationWrapper>
    <Text>{message}</Text>
  </NotificationWrapper>
);

export { NotificationProvider, Notification };